<template>
    <div class="flex items-center">
        <div class="flex items-center mr-2" style="text-align: right;" v-if="!cont">
            <vx-tooltip :text="$t('isc')" position="left">
                <feather-icon @click="clickFinish()" :badge="limit.onway" class="cursor-pointer" icon="BookmarkIcon" style="right: 0;" svg-classes="w-6 h-6"/>
            </vx-tooltip>
        </div>
        <Counter v-if="!cont" />
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import Counter from "../../components/Counter.vue";
export default {
    name: "ContentTop",
    components:{
        Counter,
    },
    props:{
        cont:Boolean
    },
    methods:{
        clickFinish(){
            this.$emit('clickFinish')
        }
    },
    computed:{
        ...mapGetters({
            limit: "regis_discepline/limitDiscepline"
        }),
    }
};
</script>

<style scoped>

</style>
